import {request, serviceUrl} from "@/utils/request";

//分页获取日志内容
export function logInfoPage(params) {
    return request({
        method: 'post',
        url: serviceUrl.extensionService + '/ext/log/page',
        data: params
    })
}

// 导出设备操作日志的Excel
export function deviceOperationLog(params) {
    return request({
        method: 'post',
        url: serviceUrl.extensionService + '/ext/log/deviceOperationLog/export-excel',
        data: params,
        responseType: 'arraybuffer'
    })
}

// 导出系统操作日志的Excel
export function userOperationLog(params) {
    return request({
        method: 'post',
        url: serviceUrl.extensionService + '/ext/log/userOperationLog/export-excel',
        data: params,
        responseType: 'arraybuffer'
    })
}